{
  "AGENT_MGMT": {
    "HEADER": "Операторы",
    "HEADER_BTN_TXT": "Добавить оператора",
    "LOADING": "Загружаем список операторов",
    "DESCRIPTION": "Агент является членом вашей службы поддержки, который может просматривать и отвечать на пользовательские сообщения. В приведенном ниже списке показаны все агенты в вашей учетной записи.",
    "LEARN_MORE": "Узнать о ролях пользователей",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Администратор",
      "AGENT": "Оператор"
    },
    "TABS": {
      "ACTIVE": "Активные",
      "DEACTIVATED": "Деактивированные"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Отключить телефон",
      "API": {
        "SUCCESS_MESSAGE": "Телефон оператора успешно отключён",
        "ERROR_MESSAGE": "Не удалось отключить телефон оператора, попробуйте позже"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Активировать",
      "API": {
        "SUCCESS_MESSAGE": "Оператор успешно активирован",
        "ERROR_MESSAGE": "Не удалось активировать оператора, попробуйте позже"
      },
      "CONFIRM": {
        "TITLE": "Подтвердите активацию",
        "MESSAGE": "Вы уверены, что хотите активировать ",
        "YES": "Да, активировать ",
        "NO": "Нет, отмена "
      }
    },
    "LIST": {
      "404": "Нет связанных с этим аккаунтом операторов",
      "TITLE": "Управляйте операторами вашей команды",
      "DESC": "Вы можете добавить или убрать операторов вашей команды.",
      "NAME": "Имя",
      "EMAIL": "Email",
      "STATUS": "Статус",
      "ACTIONS": "Действия",
      "VERIFIED": "Подтвержденный",
      "VERIFICATION_PENDING": "Неподтвержденный",
      "API_ALLOWED": "API разрешен",
      "AVAILABLE_CUSTOM_ROLE": "Доступные права для пользовательских ролей"
    },
    "ADD": {
      "TITLE": "Добавить оператора",
      "DESC": "Вы можете добавить операторов для работы с входящими сообщениями.",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "NAME": {
          "LABEL": "Имя оператора",
          "PLACEHOLDER": "Пожалуйста введите имя оператора"
        },
        "AGENT_TYPE": {
          "LABEL": "Тип оператора",
          "PLACEHOLDER": "Пожалуйста выберите тип",
          "ERROR": "Тип оператора обязателен"
        },
        "EMAIL": {
          "LABEL": "Email",
          "PLACEHOLDER": "Пожалуйста введите email оператора"
        },
        "SUBMIT": "Добавить оператора"
      },
      "API": {
        "SUCCESS_MESSAGE": "Оператор добавлен",
        "EXIST_MESSAGE": "Такой email уже используется, пожалуйста введите другой адрес",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Оператор удален",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      },
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "DESCRIPTION": "Оператор будет немедленно разлогинен, удалён из всех команд и источников и больше не сможет получить доступ к этому аккаунту.",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      }
    },
    "EDIT": {
      "TITLE": "Редактировать оператора",
      "FORM": {
        "NAME": {
          "LABEL": "Имя оператора",
          "PLACEHOLDER": "Пожалуйста введите имя оператора"
        },
        "AGENT_TYPE": {
          "LABEL": "Тип оператора",
          "PLACEHOLDER": "Пожалуйста выберите тип",
          "ERROR": "Тип оператора обязателен"
        },
        "EMAIL": {
          "LABEL": "Email",
          "PLACEHOLDER": "Пожалуйста введите email оператора"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Доступность",
          "PLACEHOLDER": "Пожалуйста, выберите статус доступности",
          "ERROR": "Необходимо наличие данных"
        },
        "API_ACCESS": {
          "LABEL": "Разрешить доступ к API",
          "HELP": "По умолчанию доступ к API отключен. Включение этой опции позволяет использовать персональный API-ключ этого оператора во всех аккаунтах, в которых он состоит. Вход в панель управления при этом не затрагивается."
        },
        "SUBMIT": "Редактировать оператора"
      },
      "BUTTON_TEXT": "Редактировать",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Оператор сохранен",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Восстановить пароль",
        "ADMIN_SUCCESS_MESSAGE": "Email с инструкциями по восстановлению пароля отправлен оператору",
        "SUCCESS_MESSAGE": "Пароль оператора сброшен",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Результаты не найдены."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Ничего",
      "TITLE": {
        "AGENT": "Выбрать Агента",
        "TEAM": "Выберите команду"
      },
      "LIST": {
        "NONE": "Ничего"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Операторы не найдены",
          "TEAM": "Команды не найдены"
        },
        "PLACEHOLDER": {
          "AGENT": "Поиск агентов",
          "TEAM": "Поиск команд",
          "INPUT": "Поиск агентов"
        }
      }
    }
  }
}
